<template>
  <div>
    <div id="content">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="dleft">
            <div class="anl">
              
              <el-input
                type="textarea"
                :rows="4"
                v-model="addText"
                placeholder="输入用逗号分割的 qid 题号字符串，例如 S1,S2,S3"
                resize="none"
              ></el-input>
              <div style="margin-top: 12px">
                <el-button
                  size="small"
                  type="primary"
                  :loading="loading"
                  @click="addLoudou"
                >
                  <i class="el-icon-plus"></i>添加
                </el-button>
              </div>
            </div>
            <div class="anl list-head" v-if="list.length > 0">
              <span style="font-size: 13px; color: #afafaf"
                >已创建漏斗题，共 {{ list.length }} 个</span
              >
              <el-button
                type="danger"
                plain
                size="mini"
                round
                style="margin-left: 16px"
                :loading="clearLoading"
                @click="clearAll"
              ><i class="el-icon-delete"></i>清除</el-button>
            </div>
            <el-table
              :data="list"
              style="width: 100%; margin-top: 20px"
              stripe
              border
              size="mini"
              empty-text="暂无漏斗题"
            >
              <el-table-column label="变量名" min-width="220">
                <template #default="scope">
                  <span :class="{ 'row-active': scope.row.id === currentId }">{{
                    qidsJoin(scope.row.qids)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180">
                <template #default="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    round
                    @click="viewLoudou(scope.row)"
                  >
                    <i class="el-icon-view"></i>查看
                  </el-button>
                  <el-button
                    type="danger"
                    size="mini"
                    plain
                    round
                    @click="delLoudou(scope.row, scope.$index)"
                  >
                    <i class="el-icon-delete"></i>删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="dright" v-if="currentId !== null">
            <div class="anl">
              <span style="font-size: 13px; color: #afafaf"
                >当前漏斗题（id={{ currentId }}），共
                {{ rightItems.length }} 个变量；可拖拽排序</span
              >
            </div>
            <el-table
              :data="rightItems"
              style="width: 100%"
              border
              size="mini"
              row-key="qid"
              ref="rightTable"
            >
              <el-table-column label="" width="40">
                <template #default>
                  <i class="el-icon-rank drag-handle" title="拖拽排序"></i>
                </template>
              </el-table-column>
              <el-table-column label="变量" min-width="180">
                <template #default="scope">
                  <el-input
                    v-if="scope.row.editing"
                    v-model="scope.row.label"
                    size="mini"
                    @blur="finishEdit(scope.row)"
                    @keyup.enter.native="finishEdit(scope.row)"
                  ></el-input>
                  <span
                    v-else
                    class="qid-text"
                    @click="startEdit(scope.row)"
                    title="点击编辑"
                  >
                    {{ scope.row.qid }}
                    <span class="qid-label">{{ scope.row.label }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="转化率" width="80" align="center">
                <template #default="scope">
                  <el-checkbox
                    v-model="scope.row.rate"
                    :disabled="scope.$index === 0"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90" align="center">
                <template #default="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    plain
                    circle
                    icon="el-icon-delete"
                    @click="removeRight(scope.$index)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 16px; text-align: right">
              <el-button
                size="small"
                type="primary"
                :loading="saveLoading"
                @click="saveRight"
              >
                <i class="el-icon-check"></i>保存修改
              </el-button>
            </div>
          </div>
          <div v-else class="dright placeholder">
            点击左侧"查看"按钮以编辑漏斗题
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";

export default {
  name: "KpiLoudou",
  props: ["kid", "pid"],
  data() {
    return {
      loading: false,
      saveLoading: false,
      clearLoading: false,
      addText: "",
      list: [],
      currentId: null,
      rightItems: [],
      rowSortable: null,
    };
  },
  created() {
    localStorage.setItem("kpitag", "loudou");
    this.loadList();
  },
  beforeDestroy() {
    if (this.rowSortable) {
      this.rowSortable.destroy();
      this.rowSortable = null;
    }
  },
  methods: {
    qidsJoin(qids) {
      if (!Array.isArray(qids)) return "";
      return qids.map((q) => q.qid).join(",");
    },
    startEdit(row) {
      this.$set(row, 'editing', true);
      this.$nextTick(() => {
        const input = document.querySelector('.el-input__inner');
        if (input) input.focus();
      });
    },
    finishEdit(row) {
      this.$set(row, 'editing', false);
    },
    loadList() {
      var api = this.COMMON.httpUrl + "kpiLoudouSelect";
      var data = { pid: this.pid, kid: this.kid };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.list = rs.data || [];
        }
      });
    },
    addLoudou() {
      var qid = (this.addText || "").replace(/\s+/g, "");
      if (!qid) {
        this.$message.warning("请输入 qid 题号");
        return;
      }
      this.loading = true;
      var api = this.COMMON.httpUrl + "kpiLoudouSave";
      var data = { pid: this.pid, kid: this.kid, qid: qid };
      this.axios.post(api, data).then((response) => {
        this.loading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message || "添加成功");
          this.addText = "";
          if (rs.data && rs.data.id) {
            this.list.push(rs.data);
          } else {
            this.loadList();
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    viewLoudou(row) {
      this.currentId = row.id;
      var rateSet = {};
      var rateArr = Array.isArray(row.rate_qids) ? row.rate_qids : [];
      for (var i = 0; i < rateArr.length; i++) {
        rateSet[rateArr[i].qid] = true;
      }
      var qids = Array.isArray(row.qids) ? row.qids : [];
      this.rightItems = qids.map(function (q) {
        return {
          qid: q.qid,
          label: q.label || "",
          rate: !!rateSet[q.qid],
          editing: false,
        };
      });
      this.$nextTick(() => {
        this.initRowSortable();
      });
    },
    delLoudou(row, index) {
      this.$confirm("确定删除该漏斗题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var api = this.COMMON.httpUrl + "kpiLoudouDel";
          var data = { id: row.id };
          this.axios.post(api, data).then((response) => {
            var rs = response.data;
            if (rs.code) {
              this.$message.error(rs.message);
            } else {
              this.list.splice(index, 1);
              if (this.currentId === row.id) {
                this.currentId = null;
                this.rightItems = [];
              }
              this.$message.success(rs.message || "删除成功");
            }
          });
        })
        .catch(() => {});
    },
    clearAll() {
      this.$confirm("确定清除全部已创建的漏斗题？此操作不可恢复。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.clearLoading = true;
          var api = this.COMMON.httpUrl + "kpiLoudouClear";
          var data = { pid: this.pid, kid: this.kid };
          this.axios
            .post(api, data)
            .then((response) => {
              this.clearLoading = false;
              var rs = response.data;
              if (rs.code) {
                this.$message.error(rs.message);
              } else {
                this.list = [];
                this.currentId = null;
                this.rightItems = [];
                this.$message.success(rs.message);
              }
            })
            .catch(() => {
              this.clearLoading = false;
            });
        })
        .catch(() => {});
    },
    removeRight(index) {
      var removed = this.rightItems[index];
      this.rightItems.splice(index, 1);
      if (index === 0 && this.rightItems.length > 0) {
        this.rightItems[0].rate = false;
      }
      void removed;
    },
    saveRight() {
      if (this.currentId === null) {
        this.$message.warning("请先选择一条漏斗题");
        return;
      }
      if (this.rightItems.length < 2) {
        this.$message.warning("漏斗题至少需要 2 个变量");
        return;
      }
      var qids = this.rightItems.map(function (r) {
        return { label: r.label, qid: r.qid };
      });
      var rate_qids = [];
      for (var i = 0; i < this.rightItems.length; i++) {
        if (i > 0 && this.rightItems[i].rate) {
          rate_qids.push({
            qid: this.rightItems[i].qid,
            from_qid: this.rightItems[i - 1].qid,
          });
        }
      }
      this.saveLoading = true;
      var api = this.COMMON.httpUrl + "kpiLoudouUpdate";
      var data = {
        id: this.currentId,
        qids: qids,
        rate_qids: rate_qids,
      };
      this.axios.post(api, data).then((response) => {
        this.saveLoading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message || "保存成功");
          var updated = rs.data || {
            id: this.currentId,
            qids: qids,
            rate_qids: rate_qids,
          };
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].id === this.currentId) {
              this.$set(this.list, i, Object.assign({}, this.list[i], updated));
              break;
            }
          }
        }
      }).catch(() => {
        this.saveLoading = false;
      });
    },
    initRowSortable() {
      if (this.rowSortable) {
        this.rowSortable.destroy();
        this.rowSortable = null;
      }
      var tableEl = this.$refs.rightTable && this.$refs.rightTable.$el;
      if (!tableEl) return;
      var tbody = tableEl.querySelector(".el-table__body-wrapper tbody");
      if (!tbody) return;
      var self = this;
      this.rowSortable = Sortable.create(tbody, {
        animation: 200,
        handle: ".drag-handle",
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        onEnd: function (evt) {
          if (evt.oldIndex === evt.newIndex) return;
          var parent = evt.from;
          parent.removeChild(evt.item);
          var ref = parent.children[evt.oldIndex] || null;
          parent.insertBefore(evt.item, ref);
          var item = self.rightItems.splice(evt.oldIndex, 1)[0];
          self.rightItems.splice(evt.newIndex, 0, item);
          if (self.rightItems.length > 0) {
            self.rightItems[0].rate = false;
          }
        },
      });
    },
  },
};
</script>

<style scoped>
#content {
  background-color: white;
  padding: 30px 40px;
}
.dleft {
  width: 100%;
}
.dright {
  width: 100%;
}
.dright.placeholder {
  border: 1px dashed #dcdfe6;
  color: #afafaf;
  font-size: 13px;
  text-align: center;
  padding: 60px 0;
  border-radius: 4px;
  margin-top: 8px;
}
.anl {
  margin-bottom: 12px;
}
.tip {
  font-size: 12px;
  color: #909399;
  margin: 0 0 8px 0;
}
.row-active {
  color: #409eff;
  font-weight: 600;
}
.qid-text {
  font-weight: 600;
  color: #303133;
  margin-right: 8px;
  cursor: pointer;
}
.qid-text:hover {
  color: #409eff;
}
.qid-label {
  color: #909399;
  font-size: 12px;
}
.drag-handle {
  cursor: grab;
  color: #b0b3b8;
  font-size: 14px;
  transition: color 0.2s;
}
.drag-handle:hover {
  color: #e6a23c;
}
.drag-handle:active {
  cursor: grabbing;
  color: #c78c30;
}
.sortable-ghost {
  background-color: #ecf5ff !important;
  opacity: 0.6;
}
.sortable-chosen {
  background-color: #d9ecff !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}
:deep(.el-table) {
  font-size: 13px;
}
:deep(.el-table th.el-table__cell) {
  background-color: #f5f7fa;
}
</style>
